import React, { Component, Fragment } from 'react';
import DevotionalGroupGrid from './grid/DevotionalGroupGrid.js';
import { Messages } from "../../_locale/locale.en";
import Button from "@material-ui/core/Button/Button";
import { withStyles } from "@material-ui/styles";
import { styles } from "../devotees/DevoteeContainer.styles";
import { theme } from "../../layout/Layout.theme";

class DevotionalGroupsContainer extends Component {
  render () {
    const { classes } = this.props;
    return (
      <Fragment>
        <Button style={{ marginBottom: '20px' }} variant="contained" color="secondary" className={classes.button}>
          {Messages.DevotionalGroupContainer.Buttons.AddDevotionalGroup}
        </Button>
        <DevotionalGroupGrid />
      </Fragment>
    )
  }
}

export default (
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(DevotionalGroupsContainer));
